import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import MaterialTableHead from '@material-ui/core/TableHead';
import ReportSummaryContext from '@/modules/reports/contexts/ReportSummaryContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';
import { formatDate } from '~/common';

const TableHead = (props) => {
    // noinspection JSCheckFunctionSignatures
    const reportSummaryContext = useContext(ReportSummaryContext);

    return (
        <MaterialTableHead><TableRow>
            {props.days.map((date, id) => (
                <TableCellOrder key={id} className="count"
                                orderName={formatDate(date, 'yyyy-MM-dd')} ordering={reportSummaryContext.ordering}
                                onClick={reportSummaryContext.handleClickOrder}
                >
                    {formatDate(date, 'dd.MM')}
                </TableCellOrder>
            ))}
        </TableRow></MaterialTableHead>
    );
};

TableHead.propTypes = {
    days: PropTypes.array.isRequired,
};

export default TableHead;
